import axios from 'axios'
import config from './config'

const jsonRequest = axios.create({
  baseURL: config.API_URL
})

export default {
  mainAdmin: {
    login(payload) {
      return jsonRequest.post('/mainadmin/login', payload)
    },
    verifyMainAdminToken(payload) {
      return jsonRequest.post('mainadmin/token/verify', payload)
    },
    sendForgotPasswordEmail(payload) {
      return jsonRequest.post('/mainadmin/forgot-password/email', payload)
    },
    verifyResetPasswordLink(payload) {
      return jsonRequest.post('/mainadmin/verify-reset-password-link', payload)
    },
    resetPassword(payload) {
      return jsonRequest.post('/mainadmin/reset-password', payload)
    },
    changePassword(payload) {
      return jsonRequest.post('/mainadmin/change-password', payload)
    },
    getErrorList(payload) {
      return jsonRequest.post('/mainadmin/error-list', payload)
    },
    getErrorDetail(payload) {
      return jsonRequest.post('/mainadmin/error-detail', payload)
    }
  },
  schoolUser: {
    login(payload) {
      return jsonRequest.post('/schooluser/login', payload)
    },
    verifySchoolUserToken(payload) {
      return jsonRequest.post('/schooluser/token/verify', payload)
    },
    sendForgotPasswordEmail(payload) {
      return jsonRequest.post('/schooluser/forgot-password/email', payload)
    },
    verifyResetPasswordLink(payload) {
      return jsonRequest.post('/schooluser/verify-reset-password-link', payload)
    },
    resetPassword(payload) {
      return jsonRequest.post('/schooluser/reset-password', payload)
    },
  },
  school: {
    getSchools(payload) {
      return jsonRequest.post('/schools', payload)
    },
    deleteSchool(payload) {
      return jsonRequest.post('/school/delete', payload)
    },
    getSchoolList(payload) {
      return jsonRequest.post('/school/list', payload)
    },
    getSchoolDetail(payload) {
      return jsonRequest.post('/school/detail', payload)
    },
    saveSchool(payload) {
      return jsonRequest.post('/school/save', payload)
    },
    getSchoolInstructors(payload) {
      return jsonRequest.post('/instructors/school', payload)
    },
    getSchoolStudents(payload) {
      return jsonRequest.post('/students/school', payload)
    },
    getAddressTypesForSchool(payload) {
      return jsonRequest.post('/addresstypes/school', payload)
    },
    getSchoolUserTypes(payload) {
      return jsonRequest.post('/usertypes/school', payload)
    },
    getSchoolQualifications(payload) {
      return jsonRequest.post('/qualifications/school', payload)
    },
    getSchoolStaffsByUserType(payload) {
      return jsonRequest.post('/staffs/school', payload)
    },
    getSchoolSalesTax(payload) {
      return jsonRequest.post('/salestax/school', payload)
    },
    getSchoolAddresses(payload) {
      return jsonRequest.post('/addresses/school', payload)
    },
    getSchoolAddressCountries(payload) {
      return jsonRequest.post('/address-countries/school', payload)
    }
  },
  instructor: {
    getInstructorUserTypes(payload) {
      return jsonRequest.post('/instructor/usertypes', payload)
    },
    getInstructorList(payload) {
      return jsonRequest.post('/instructor/list', payload)
    },
    deleteInstructor(payload) {
      return jsonRequest.post('/instructor/delete', payload)
    },
    saveInstructor(payload) {
      return jsonRequest.post('/instructor/save', payload)
    },
    getInstructorDetail(payload) {
      return jsonRequest.post('/instructor/detail', payload)
    },
    getAddressTypesForInstructor(payload) {
      return jsonRequest.post('/addresstypes/instructor', payload)
    },
    getEmailTypesForInstructor(payload) {
      return jsonRequest.post('/emailtypes/instructor', payload)
    },
    getContactNumberTypesForInstructor(payload) {
      return jsonRequest.post('/contactnumbertypes/instructor', payload)
    },
    getInstructorStudents(payload) {
      return jsonRequest.post('/students/instructor', payload)
    },
    getInstructorStudentsForDropdown(payload) {
      return jsonRequest.post('/students/instructor/dropdown', payload)
    },
    getInstructorStudentsDocuments(payload) {
      return jsonRequest.post('/students-documents/instructor', payload)
    },
    getInstructorClasses(payload) {
      return jsonRequest.post('/classes/instructor', payload)
    },
    getTeachingLevelsForInstructor(payload) {
      return jsonRequest.post('/teachinglevels/instructor', payload)
    },
    getInstructorCountries(payload) {
      return jsonRequest.post('/countries/instructor', payload)
    }
  },
  student: {
    getStudentList(payload) {
      return jsonRequest.post('/student/list', payload)
    },
    deleteStudent(payload) {
      return jsonRequest.post('/student/delete', payload)
    },
    saveStudent(payload) {
      return jsonRequest.post('/student/save', payload)
    },
    getStudentDetail(payload) {
      return jsonRequest.post('/student/detail', payload)
    },
    getAddressTypesForStudent(payload) {
      return jsonRequest.post('/addresstypes/student', payload)
    },
    getAddressTypesForGuardian(payload) {
      return jsonRequest.post('/addresstypes/guardian', payload)
    },
    getEmailTypesForStudent(payload) {
      return jsonRequest.post('/emailtypes/student', payload)
    },
    getContactNumberTypesForStudent(payload) {
      return jsonRequest.post('/contactnumbertypes/student', payload)
    },
    getSubjectLevelsForStudent(payload) {
      return jsonRequest.post('/subjectlevels/student', payload)
    },
  },

  common: {
    deleteToken(payload) {
      return jsonRequest.post('/token/delete', payload)
    },
    getCountries(payload) {
      return jsonRequest.post('/countries', payload)
    },
    getGenders(payload) {
      return jsonRequest.post('/genders', payload)
    },
    getNationalities(payload) {
      return jsonRequest.post('/nationalities', payload)
    },
    getCitizenships(payload) {
      return jsonRequest.post('/citizenships', payload)
    },
    getMaritalStatuses(payload) {
      return jsonRequest.post('/maritalstatuses', payload)
    },
    getBankAccountTypes(payload) {
      return jsonRequest.post('/bankaccounttypes', payload)
    },
    getRelationships(payload) {
      return jsonRequest.post('/relationships', payload)
    },
    getAccountInfo(payload) {
      return jsonRequest.post('/accountinfo', payload)
    },
    getCurrencies(payload) {
      return jsonRequest.post('/currencies', payload)
    },
    getSalesTaxes(payload) {
      return jsonRequest.post('/salestaxes', payload)
    },
    getTimezones(payload) {
      return jsonRequest.post('/timezones', payload)
    }
  },

  publicHoliday: {
    savePublicHoliday(payload) {
      return jsonRequest.post('/public-holiday/save', payload)
    },
    deletePublicHoliday(payload) {
      return jsonRequest.post('/public-holiday/delete', payload)
    },
    getPublicHolidayList(payload) {
      return jsonRequest.post('/public-holiday/list', payload)
    },
  },

  subject: {
    getSpecialisationSubjectsForInstructor(payload) {
      return jsonRequest.post('/specialisation-subjects/instructor', payload)
    },
    getTeachingSubjectsForInstructor(payload) {
      return jsonRequest.post('/teaching-subjects/instructor', payload)
    },
    getSubjectsForStudent(payload) {
      return jsonRequest.post('/subjects/student', payload)
    },
    getSubjectsForClass(payload) {
      return jsonRequest.post('/subjects/class', payload)
    },
    getSubjectsForClassFilter(payload) {
      return jsonRequest.post('/subjects/classfilter', payload)
    },
    getSubjects(payload) {
      return jsonRequest.post('/subjects', payload)
    },
    deleteSubject(payload) {
      return jsonRequest.post('/subject/delete', payload)
    },
    saveSubject(payload) {
      return jsonRequest.post('/subject/save', payload)
    }
  },

  class: {
    getClassDurations(payload) {
      return jsonRequest.post('/classdurations', payload)
    },
    getClassFrequencies(payload) {
      return jsonRequest.post('/classfrequencies', payload)
    },
    getClassLocations(payload) {
      return jsonRequest.post('/classlocations', payload)
    },
    validateSaveClass(payload) {
      return jsonRequest.post('/class/save/validate', payload)
    },
    saveClass(payload) {
      return jsonRequest.post('/class/save', payload)
    },
    getClassDetail(payload) {
      return jsonRequest.post('/class/detail', payload)
    },
    getSubjectLevelsForClassFilter(payload) {
      return jsonRequest.post('/subjectlevels/classfilter', payload)
    },
    getDurationsForClassFilter(payload) {
      return jsonRequest.post('/durations/classfilter', payload)
    },
    getFrequenciesForClassFilter(payload) {
      return jsonRequest.post('/frequencies/classfilter', payload)
    },
    deleteClass(payload) {
      return jsonRequest.post('/class/delete', payload)
    },
    getClassList(payload) {
      return jsonRequest.post('/class/list', payload)
    },
    getSubjectLevelsForClass(payload) {
      return jsonRequest.post('/subjectlevels/class', payload)
    },
    getClassListByMonth(payload) {
      return jsonRequest.post('/class/list/month', payload)
    },
    getClassListByWeek(payload) {
      return jsonRequest.post('/class/list/week', payload)
    },
    getClassListByDay(payload) {
      return jsonRequest.post('/class/list/day', payload)
    },
  },

  classBooking: {
    getSubjectLevelsForClassBooking(payload) {
      return jsonRequest.post('/subjectlevels/classbooking', payload)
    },
    getDurationsForClassBooking(payload) {
      return jsonRequest.post('/durations/classbooking', payload)
    },
    getLocationsForClassBooking(payload) {
      return jsonRequest.post('/locations/classbooking', payload)
    },
    getInstructorsForClassBooking(payload) {
      return jsonRequest.post('/instructors/classbooking', payload)
    },
    getInfosForClassBooking(payload) {
      return jsonRequest.post('/infos/classbooking', payload)
    },
    saveClassBooking(payload) {
      return jsonRequest.post('/classbooking/save', payload)
    },
    getClassBookingDetail(payload) {
      return jsonRequest.post('/classbooking/detail', payload)
    },
    deleteClassBooking(payload) {
      return jsonRequest.post('/classbooking/delete', payload)
    },
    getClassBookingList(payload) {
      return jsonRequest.post('/classbooking/list', payload)
    },
    cancelClassBooking(payload) {
      return jsonRequest.post('/classbooking/cancel', payload)
    },
    confirmClassBooking(payload) {
      return jsonRequest.post('/classbooking/confirm', payload)
    },
    changeClassBookingToPending(payload) {
      return jsonRequest.post('/classbooking/changetopending', payload)
    },
    checkDuplicateClassBooking(payload) {
      return jsonRequest.post('/classbooking/checkduplicate', payload)
    },
    checkOverlapMakeupClass(payload) {
      return jsonRequest.post('/classbooking/checkoverlapmakeupclass', payload)
    },
    reportError(payload) {
      return jsonRequest.post('/classbooking/reporterror', payload)
    },
    getNonFullyBookedInstructors(payload) {
      return jsonRequest.post('/classbooking/getNonFullyBookedInstructors', payload)
    },
    getClassBookingListByMonth(payload) {
      return jsonRequest.post('/classbooking/list/month', payload)
    },
    getClassBookingListByWeek(payload) {
      return jsonRequest.post('/classbooking/list/week', payload)
    },
    getClassBookingListByDay(payload) {
      return jsonRequest.post('/classbooking/list/day', payload)
    },
  },

  document: {
    getDocumentUserTypes(payload) {
      return jsonRequest.post('/document/usertypes', payload)
    },
    getDocumentList(payload) {
      return jsonRequest.post('/document/list', payload)
    },
    deleteDocument(payload) {
      return jsonRequest.post('/document/delete', payload)
    },
    addDocument(payload) {
      return jsonRequest.post('/document/add', payload)
    },
    getDocumentFile(payload) {
      return jsonRequest.post('/document/file', payload)
    }
  },

  schedule: {
    getTodayDate(payload) {
      return jsonRequest.post('/schedule/todaydate', payload)
    },
    getPreviousDate(payload) {
      return jsonRequest.post('/schedule/previousdate', payload)
    },
    getNextDate(payload) {
      return jsonRequest.post('/schedule/nextdate', payload)
    },
    getDisplayedPeriod(payload) {
      return jsonRequest.post('/schedule/displayedperiod', payload)
    },
    getScheduleByMonth(payload) {
      return jsonRequest.post('/schedule/month', payload)
    },
    getScheduleByWeek(payload) {
      return jsonRequest.post('/schedule/week', payload)
    },
    getScheduleByDay(payload) {
      return jsonRequest.post('/schedule/day', payload)
    },
    getEventByMonth(payload) {
      return jsonRequest.post('/event/month', payload)
    },
    getEventByWeek(payload) {
      return jsonRequest.post('/event/week', payload)
    },
    getEventByDay(payload) {
      return jsonRequest.post('/event/day', payload)
    },
    saveEvent(payload) {
      return jsonRequest.post('/event/save', payload)
    },
    deleteEvent(payload) {
      return jsonRequest.post('/event/delete', payload)
    }
  }
}


// WEBPACK FOOTER //
// ./src/http-common.js